<p-dialog
  [(visible)]="showModal"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onClose()"
>
  <p-confirmDialog
    key="deleteProjectConfirmation"
    [style]="{ width: '40vw' }"
    [baseZIndex]="10000"
  ></p-confirmDialog>
  <ng-template pTemplate="header">
    <h3>{{ title }}</h3>
  </ng-template>

  <div class="p-grid">
    <div class="p-col-12">
      <app-edit-project></app-edit-project>
    </div>
    <div class="p-col-12">
      <app-create-project></app-create-project>
    </div>
    <div
      class="p-col-12"
      *ngIf="showModal && !showCreateProject && !showEditProject"
    >
      <div [class]="isOpenProjectDw ? 'openDw' : 'closeDw'">
        <h4>Select context:</h4>
        <div class="p-fluid p-mb-4 p-mt-4">
          <div class="p-grid">
            <div class="p-col-9  p-field">
              <p-dropdown
                [filter]="true"
                filterBy="name"
                (onShow)="showDwOptions()"
                (onHide)="closeDwOptions()"
                (onFocus)="closeDwOptions()"
                (onChange)="selectOneItem($event)"
                placeholder="Select a context"
                [options]="projects"
                optionLabel="name"
                [(ngModel)]="projectSelected"
              >
                <ng-template pTemplate="selectedItem" let-selectedProject>
                  <div>{{ selectedProject.name }}</div>
                </ng-template>
                <ng-template pTemplate="item" let-project>
                  <div class="project-option">
                    <span class="project-option-logo-slot">
                      <img
                        [src]="getProjectLogo(project.value)"
                        (error)="onImageError($event)"
                        class="project-option-logo"
                        alt=""
                      />
                    </span>
                    <span class="project-option-name">{{ project.name }}</span>
                    <small class="project-option-caption">
                      {{ getProjectCaption(project) }}
                    </small>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
            <div class="p-col-3  p-field-checkbox my-projects-filter">
              <p-checkbox
                id="showMyProjectsOnly"
                [(ngModel)]="showMyProjectsOnly"
                [binary]="true"
                (onChange)="handleShowMyProjectsOnlyChange()"
              ></p-checkbox>
              <label for="showMyProjectsOnly">Show My Contexts Only</label>
            </div>
          </div>
        </div>
      </div>
      <div class="project-actions" *ngIf="isAdmin()">
        <div class="box-button-left">
          <button
            icon="pi pi-pencil"
            pButton
            pRipple
            type="button"
            label="Edit Context"
            class="p-mr-2"
            (click)="openProjectSettings()"
            pTooltip="Edit"
            tooltipPosition="top"
          ></button>
          <p-button
                    icon="pi pi-plus"
                    type="button"
                    label="New Context"
                    (click)="handleCreateProject()"
                    [disabled]="disableNewProject"
                    class="create p-mr-2"
          ></p-button>
          <button
            icon="pi pi-arrow-right-arrow-left"
            pButton
            pRipple
            type="button"
            label="Transfer Context"
            class="p-mr-2"
            [disabled]="!projectSelected"
            (click)="openTransferProject()"
          ></button>
          <button
            icon="pi pi-trash"
            pButton
            pRipple
            type="button"
            label="Delete Context"
            class="p-mr-2"
            (click)="deleteProject()"
            pTooltip="Delete Context"
            tooltipPosition="top"
          ></button>
        </div>
      </div>
    </div>
    <div
      class="p-col-12 p-mb-lg-auto"
      *ngIf="showModal && !showCreateProject && !showEditProject"
    >
      <div class="p-fluid p-mb-4">
        <div class="p-field"></div>
      </div>
    </div>
  </div>
</p-dialog>
<app-transfer-project
  *ngIf="transferProject"
  [project]="transferProject"
  (closed)="transferProject = null"
  (transferred)="handleProjectTransferred($event)"
></app-transfer-project>
